import React from "react";
import NirvaContentCard from "../../../../../components/Content/NirvaContentCard";

import { SectionTitle } from "../../Nirva.styles";
import { SectionWrapper, StyledGrid } from "./PolicySection.styles";

const PolicySection = ({ title, policies }) => {
  return (
    <>
      <SectionWrapper>
        <SectionTitle>{title}</SectionTitle>
      </SectionWrapper>
      <StyledGrid container spacing={2}>
        {policies.map((item) => (
          <NirvaContentCard
            key={item.id}
            title={item.title}
            link={item.link}
          />
        ))}
      </StyledGrid>
    </>
  );
};

export default PolicySection;
